module.exports = __webpack_public_path__ + "img/2026big12.c0e6f409.png";